import React, { FC } from 'react'
import { Tooltip } from 'antd'

import { QuestionCircleOutlined } from '../icons/index'
import styles from './form-label-with-hint.module.scss'

interface Props {
  label: string
  hint: React.ReactNode
  overlayClassName?: string
  placement?:
    | 'right'
    | 'top'
    | 'left'
    | 'bottom'
    | 'topLeft'
    | 'topRight'
    | 'bottomLeft'
    | 'bottomRight'
    | 'leftTop'
    | 'leftBottom'
    | 'rightTop'
    | 'rightBottom'
    | undefined
}

const FormLabelWithHint: FC<Props> = (props) => {
  const { label, hint, overlayClassName, placement = 'right' } = props

  return (
    <Tooltip placement={placement} title={hint} trigger={['hover', 'click']} overlayClassName={overlayClassName}>
      <div className={styles.root}>
        <span>{label}</span>
        <QuestionCircleOutlined size={16} className={styles.icon} />
      </div>
    </Tooltip>
  )
}

export default FormLabelWithHint
